export interface CalendarState {
  anomalies: Map<any, any>
  events: Map<any, any>
  campaigns: Map<any, any>
  gaCampaigns: string[]
  kpis: Map<any, any>
  kpiMetrics: string[]
  goals: Map<any, any>
  goalMetrics: string[]
}

export const initialState = {
  anomalies: new Map(),
  events: new Map(),
  campaigns: new Map(),
  gaCampaigns: [],
  kpis: new Map(),
  kpiMetrics: [],
  goals: new Map(),
  goalMetrics: [],
}

export const calendar = (
  state: CalendarState = initialState,
  action: ReduxAction,
): CalendarState => {
  switch (action.type) {
    case 'UPDATE_CAL_ANOMALY_RANGE':
      return {
        ...state,
        anomalies: new Map([...action.payload]),
      }
    case 'UPDATE_CAL_EVENTS':
      return {
        ...state,
        events: new Map([...action.payload]),
      }
    case 'UPDATE_CAL_CAMPAIGNS':
      // HACK: this removes items with the same date
      return {
        ...state,
        campaigns: new Map([...action.payload]),
      }
    case 'UPDATE_CAL_GA_CAMPAIGNS':
      return {
        ...state,
        gaCampaigns: [...action.payload],
      }
    case 'UPDATE_CAL_KPI_METRICS':
      return {
        ...state,
        kpiMetrics: [...action.payload],
      }
    case 'UPDATE_CAL_KPIS':
      return {
        ...state,
        kpis: new Map([...action.payload]),
      }
    case 'UPDATE_CAL_GOAL_METRICS':
      return {
        ...state,
        goalMetrics: [...action.payload],
      }
    case 'UPDATE_CAL_GOALS':
      return {
        ...state,
        goals: new Map([...action.payload]),
      }
    default:
      return state
  }
}
